import { render, staticRenderFns } from "./AmicableForm.vue?vue&type=template&id=34b180e4&scoped=true&"
import script from "./AmicableForm.vue?vue&type=script&lang=js&"
export * from "./AmicableForm.vue?vue&type=script&lang=js&"
import style0 from "./AmicableForm.vue?vue&type=style&index=0&id=34b180e4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34b180e4",
  null
  
)

export default component.exports